import React, {useState, useRef} from 'react'
import {useSelector} from 'react-redux';
import BudgetSurrender from '../../components/BudgetSurrender/BudgetSurrender';
import CreateButton from '../../components/Tools/CreateButton';
import SubHeader from '../../components/Subheader/Subheader';
import MainFilter from '../../components/Tools/MainFilter';
import DashboardFilter from '../Dashboard/components/DashboardFilter';
import CustomBreadcrumbs from '../../components/Tools/Breadcumbs';


export default function BudgetSurrenderList() {
    const {financialYears,authData} = useSelector((state) => state.authData);
    const fyList = financialYears.payload.fy_list;
    const fyIdRef = useRef(localStorage.getItem('globalDateId'));
    const [filterPayload, setFilterPayload] = useState({
            searchStr: "",
            fromDate: "",
            toDate: "",
            dateColumn: "",
            department_id: "",
            tier: "",
            consolidate: false,
        });
        const [filterApplied, setFilterApplied] = useState({
                searchStr: "",
                fromDate: "",
                toDate: "",
                dateColumn: "",
                department_id: "",
                tier: "",
                consolidate: false,
            });
        const [open, setOpen] = useState(false);
        const handleOpen = () => setOpen(true);
        const handleClose = () => setOpen(false);
        const handleInput = async (e) => {
            const {name, value} = e.target;
            setFilterPayload((prev) => ({
                ...prev, [name]: value
            }));
        }
        const bootList = async () => {
            setFilterApplied(filterPayload);
            setOpen(false);
        }
        const handleFilterRemove = async (name) => {
            const newPayload = {
            ...filterPayload,
            [name]: "",
            };
            setFilterPayload(newPayload);
            setFilterApplied(newPayload);
        }


    const handlePageTrigger = () => {
        fyIdRef.current = localStorage.getItem('globalDateId');
    }
    return (
        <div>
            <SubHeader fy_list={fyList} handlePageTrigger={handlePageTrigger}/>
            <div className="row" style={{padding: "8px 10px"}}>
                <div className="col-md-6">
                    <h4 style={{ color: "#28326f", margin: 0 }}>Budget Surrender</h4>
                    <CustomBreadcrumbs linksArray={[]} title={"Budget Surrender"} />
                </div>
                <div className="col-md-6">
                </div>
            </div>
            <div className='scheme p-2'>
                <DashboardFilter 
                    openFilterModal={setOpen} 
                    filterPayload={filterApplied} 
                    handleFilterRemove={handleFilterRemove}
                    isTierRemovalRequired={true}
                />
                <BudgetSurrender fromDate={filterApplied.fromDate} toDate={filterApplied.toDate} dateColumn={filterApplied.dateColumn} department_id={filterApplied.department_id} searchStr={filterApplied.searchStr} approved={true} fyId={fyIdRef.current}/>
            </div>
            { authData.user.user_type === 'l1' && <CreateButton title={"Add Budget Surrender"} url={"/add-budget-surrender"}/> }
            <MainFilter 
                open={open} 
                handleClose={handleClose} 
                handleInput={handleInput} 
                handleOpen={handleOpen} 
                handleFilterClick={bootList} 
                filterPayload={filterPayload}
                setConsolidate={setFilterPayload}
                type="Schemes"/>
        </div>
    )
}